const carouselItems = [
  {
    title: '高分悬疑电影大赏',
    desc: '反转不断、烧脑过瘾——精选豆瓣8.5+悬疑推理影片，每一部都让你猜不到结局。从经典密室到心理惊悚，挑战你的推理极限。',
    tag: '高分推荐',
    imgSrc: 'https://readdy.ai/api/search-image?query=A%20dark%20moody%20cinematic%20composition%20with%20warm%20amber%20light%20streaks%2C%20film%20noir%20atmosphere%2C%20elegant%20suspense%20aesthetic%2C%20deep%20shadows%20with%20coral%20accent%20highlights%2C%20wide%20cinematic%20ratio&width=1200&height=500&seq=carousel-mystery&orientation=landscape',
  },
  {
    title: '国产精品力作特辑',
    desc: '聚焦华语电影的高光时刻——从文艺片到商业巨制，呈现中国电影人的创造力与匠心精神。每一帧都是文化的共鸣与情感的流动。',
    tag: '国产之光',
    imgSrc: 'https://readdy.ai/api/search-image?query=A%20warm%20rich%20artistic%20wide%20composition%20with%20traditional%20Chinese%20aesthetic%20elements%2C%20elegant%20cinematic%20lighting%2C%20golden%20and%20crimson%20tones%2C%20dramatic%20atmosphere&width=1200&height=500&seq=carousel-chinese&orientation=landscape',
  },
  {
    title: '治愈系温情电影合集',
    desc: '在喧嚣的生活中，给自己一段安静的观影时光。精选最温暖人心的高分故事片，让感动在光影之间自然流淌，治愈每一个疲惫的灵魂。',
    tag: '温暖推荐',
    imgSrc: 'https://readdy.ai/api/search-image?query=A%20soft%20warm%20cinematic%20wide%20scene%20with%20golden%20sunlight%20and%20gentle%20bokeh%2C%20cozy%20atmosphere%2C%20elegant%20minimal%20composition%2C%20peaceful%20and%20comforting%20tones&width=1200&height=500&seq=carousel-warm&orientation=landscape',
  },
  {
    title: '科幻巨制视觉盛宴',
    desc: '从赛博朋克到太空史诗，精选视觉震撼的高分科幻大片。未来科技、人工智能、外星文明——打开你的想象力边界，畅游未知世界。',
    tag: '视觉奇观',
    imgSrc: 'https://readdy.ai/api/search-image?query=A%20futuristic%20cinematic%20wide%20composition%20with%20deep%20space%20background%2C%20warm%20neon%20glows%2C%20sleek%20geometric%20patterns%2C%20epic%20sci-fi%20atmosphere%20with%20coral%20and%20amber%20highlights&width=1200&height=500&seq=carousel-scifi&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            编辑精选的深度内容专题，带您走进不同的光影世界
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {carouselItems.slice(0, 4).map((item) => (
            <div
              key={item.title}
              className="relative rounded-2xl overflow-hidden bg-background-200 cursor-pointer group h-[320px] md:h-[380px]"
            >
              <img
                src={item.imgSrc}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-500/90 text-background-50 mb-3">
                  {item.tag}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-background-50/80 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}